import React from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import { MenuOutlined } from "@ant-design/icons";
import { Chatbot } from "../../../../../assets/svg";
import { Logo } from "../../../../../assets/svg/logo";
import styles from "./header.module.sass";

const cx = classNames.bind(styles);

const MobileHeader = ({
  variant = "default",
  showChatCta = true,
  onMenuClick,
  onChatClick,
}) => {
  const navigate = useNavigate();

  return (
    <header className={cx("header")}>
      {variant === "drawer" ? (
        <>
          <div className={cx("logoBox")}>
            <Logo />
          </div>
          <div className={cx("headerTitle")}>
            <h1>Trợ lý tuyển dụng AI</h1>
            <p>Tư vấn vị trí phù hợp và hỗ trợ tuyển nhanh</p>
          </div>
          <button
            type="button"
            className={cx("headerAction", "closeButton")}
            onClick={onMenuClick}
            aria-label="Đóng"
          >
            ×
          </button>
        </>
      ) : (
        <div className={cx("headerBrand")} onClick={() => navigate("/")}>
          <div className={cx("logoBox")}>
            <Logo />
          </div>
          <div className={cx("headerTitle")}>
            <h1>Trợ lý tuyển dụng AI</h1>
            <p>Tư vấn vị trí phù hợp và hỗ trợ tuyển nhanh</p>
          </div>
        </div>
      )}

      {variant === "chat" ? (
        <button
          type="button"
          className={cx("headerAction", "menuButton")}
          onClick={onMenuClick}
          aria-label="Danh sách tuyển dụng"
        >
          <MenuOutlined />
        </button>
      ) : variant !== "drawer" && showChatCta ? (
        <button
          type="button"
          className={cx("headerAction")}
          onClick={onChatClick}
          aria-label="Trò chuyện với trợ lý tuyển dụng"
        >
          <span className={cx("chatBotAvatar")} aria-hidden="true">
            <Chatbot />
          </span>
        </button>
      ) : null}
    </header>
  );
};

export default MobileHeader;
